import { isEmpty } from 'lodash';
import { translateValue } from 'utils/methods/helpers';

const visitPerson = 'VISIT_PERSON';
export const getPurposeName = purpose => {
  if (isEmpty(purpose)) return '';
  if (purpose.description === visitPerson) {
    //translate it
    const s = translateValue(purpose.description);
    if (purpose.id) {
      return `${s} ${purpose.firstName} ${purpose.lastName}`;
    }
  }
  return purpose.description;
};
